import { CommonModule } from '@angular/common';
import {
    provideHttpClient,
    withInterceptorsFromDi
} from '@angular/common/http';
import { Injector, ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { QUILL_CONFIG_TOKEN, QuillModule } from 'ngx-quill';
import Quill from 'quill';
import { FetchImageService } from './fetch-image.service';
import {
    CustomImageBlot,
    CustomMentionBlot,
    Mention,
    MentionBlot,
    quillConfigFactory
} from './mention-inlined';
import { RichTextEditorConfigService } from './rich-text-editor-config.service';
import { RichTextEditorComponent } from './rich-text-editor/rich-text-editor.component';

Quill.register({ 'formats/mention': MentionBlot });

Quill.register('modules/mention', Mention);

Quill.register({ 'formats/customImage': CustomImageBlot });

Quill.register({
    'formats/mention': CustomMentionBlot
});

@NgModule({
    exports: [QuillModule, RichTextEditorComponent],
    declarations: [RichTextEditorComponent],
    imports: [QuillModule, FormsModule, CommonModule],
    providers: [
        RichTextEditorConfigService,
        FetchImageService,
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class RichTextEditorModule {
    constructor(private injector: Injector) {
        CustomImageBlot.injector = this.injector;
    }
    static forChild(): ModuleWithProviders<RichTextEditorModule> {
        return {
            ngModule: RichTextEditorModule,
            providers: [
                RichTextEditorConfigService,
                {
                    provide: QUILL_CONFIG_TOKEN,
                    useFactory: quillConfigFactory,
                    deps: [RichTextEditorConfigService, FetchImageService]
                }
            ]
        };
    }
}
